import { isType } from '../../../../shared/utilities';
import { AppCluster, IAppClusterDisplay, IAppKey, IAppKeyDisplay } from '../../../services/appkey';
import { ICompany } from '../../../services/company';
import { IRole } from '@services/users';

export type SearchSelectDataUnion = IAppKey | IAppKeyDisplay | ICompany | AppCluster | ISearchSelectData | IRole | string;

export interface ISearchSelectData {
	name: string;
	id: string | number;
	meta?: {
		[key: string]: {
			name: string;
			data?: any;
			i18nKey?: string;
			selected?: boolean;
			class?: string;
			hide?: boolean;
			preserveCase?: boolean;
			copyable?: boolean;
		};
	};
}

export function createSearchSelectData(data: SearchSelectDataUnion): ISearchSelectData {
	if (isType<IAppKey>(data, 'clientId') || isType<IAppKeyDisplay>(data, 'clientId')) {
		return {
			name: data?.name ? data.name : data.clientId,
			id: data.clientId,
			meta: {
				provider: {
					name: data['provider'],
					selected: true,
					class: data['provider'] !== 'local' ? `badge-${data['provider']}` : ''
				},
				clientId: { name: data.clientId, copyable: true, preserveCase: true }
			}
		};
	}

	if (isType<AppCluster>(data, 'hostnames')) {
		return {
			name: data.name,
			id: data.clusterId,
			meta: {
				publicApi: {
					name: 'Private',
					i18nKey: 'app.descriptor.private',
					hide: false,
					class: 'badge-warning'
				}
			}
		};
	}

	if (isType<ICompany>(data, 'id')) {
		return {
			name: data.name,
			id: data.id,
			meta: {
				id: { name: data.id, copyable: true, preserveCase: true }
			}
		};
	}

	if (isType<IRole>(data, 'roleId')) {
		return {
			name: data.roleId,
			id: data.roleId,
			meta: {
				id: { name: data.roleId, copyable: true, preserveCase: true, hide: true }
			}
		}
	}

	if (typeof data === 'string') {
		return {
			name: data,
			id: data
		};
	}

	return data;
}
